module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-wrapper"
  }, [_c('div', {
    staticClass: "slides"
  }, _vm._l((_vm.slideList), function(slide, index) {
    return _c('Slide', {
      key: slide.id,
      attrs: {
        "isActive": _vm.isActive(index),
        "slide": slide
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "mobile-slides",
    style: ({
      backgroundImage: ("url(" + _vm.bannerImg + ")")
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3e0bb837"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/landingPage/Slider.vue
// module id = 671
// module chunks = 0